import { useEffect, useRef } from 'react';

const HEARTBEAT_MS = 60_000;

/**
 * Records active time in app.codiii.com for company usage metrics (manage portal).
 * Requires REACT_APP_COMPANY_API_URL and Cognito id_token.
 */
export default function useProductUsageHeartbeat(enabled) {
  const lastPingRef = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;

    const base = process.env.REACT_APP_COMPANY_API_URL;
    if (!base) return undefined;

    const ping = async () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastPingRef.current < HEARTBEAT_MS - 5000) return;
      lastPingRef.current = now;

      const idToken = localStorage.getItem('id_token');
      if (!idToken) return;

      try {
        await fetch(`${base.replace(/\/$/, '')}/company/usage-heartbeat`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          body: '{}',
        });
      } catch {
        // non-blocking
      }
    };

    ping();
    const interval = setInterval(ping, HEARTBEAT_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') ping();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
}
